import React from 'react';
import { FileText } from 'lucide-react';
import HomeworkCard from './HomeworkCard';

const HomeworkList = ({ homeworks, filter, searchTerm, onSubmitClick, onReviewClick }) => {
  const filteredHomework = homeworks
    .filter(hw => {
      let statusMatch = true;
      if (filter !== 'all') {
        if (filter === 'Completed') {
          statusMatch = hw.status === 'GRADED' || hw.status === 'Completed';
        } else {
          statusMatch = hw.status === filter;
        }
      }
      
      const searchMatch = !searchTerm || 
        (hw.subject && hw.subject.toLowerCase().includes(searchTerm.toLowerCase()));
      
      return statusMatch && searchMatch;
    })
    .sort((a, b) => {
      if (!a.dueDate) return 1;
      if (!b.dueDate) return -1;
      return new Date(a.dueDate) - new Date(b.dueDate);
    });

  if (filteredHomework.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm p-12 text-center border">
        <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {filter === 'all' ? 'No homework found' : `No ${filter.toLowerCase()} homework`}
        </h3>
        <p className="text-gray-600">
          {filter === 'all' 
            ? 'Your homework assignments will appear here once assigned by your tutor.'
            : `You don't have any ${filter.toLowerCase()} homework at the moment.`
          }
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-4">
      {filteredHomework.map((homework) => (
        <HomeworkCard
          key={homework.id}
          homework={homework}
          onSubmitClick={onSubmitClick}
          onReviewClick={onReviewClick}
        />
      ))}
    </div>
  );
};

export default HomeworkList;